export default "__VITE_ASSET__BE4_cSru__"